import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class CalendarService {
    constructor(private http: HttpClient) { }
    
    getAll(perPage:number, page:number) {
        return this.http.get<any>(`${environment.apiUrl}/article/article?perPage=${perPage}&page=${page}&type=schedule`)
    }
    getSchedule(perPage:number, page:number) {
        return this.http.get<any>(`${environment.apiUrl}/article/article/schedule?perPage=${perPage}&page=${page}`)
    }
    searchCalendar(perPage:number, page:number, searchQuery:any) {
        return this.http.get<any>(`${environment.apiUrl}/article/article/schedule?perPage=${perPage}&page=${page}&${searchQuery}&sort={"created_at":-1}`,)
    }

}